import React from 'react';
import {
    Row,
    Col,
    Typography,
    Statistic,
    Table,
} from 'antd';
// import {
//     FaGraduationCap
// } from "react-icons/fa";
import dayjs from 'dayjs';
import logo from '../assets/logo.png';
import qrcode from '../assets/qrcode.jpg';
import { convertPaymentType, formatPhone } from '../utils/customFunctions';

function Invoice({ orderData, orderItems, printRef }) {

    // console.log(orderData);
    // console.log('orderItems = ', orderItems);
    return (
        <div ref={printRef}>
            {
                ['ต้นฉบับ', 'สำเนา'].map((item, idx) =>
                    <div
                        key={idx}
                        style={{
                            background: '#FFF',
                            height: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <div
                            style={{
                                margin: '64px 0px 24px 0px',
                                padding: '24px 32px'
                            }}>
                            <Row justify="space-between">
                                <Col xs={4}>
                                    <div style={{ height: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        {/* <Avatar src={logo} size={200} style={{ padding: '4px', textAlign: 'center' }} /> */}

                                        {/* <div style={{width:'100%',textAlign:'center'}}> */}
                                        <img src={logo} alt='logo' width={80} />
                                        {/* </div> */}

                                        <Typography.Paragraph style={{ padding: '0px', margin: '0px', fontSize: '12px', textAlign: 'center' }}>
                                            เก่งใช้ภาษาอังกฤษ
                                        </Typography.Paragraph>
                                        <Typography.Paragraph style={{ padding: '0px', margin: '0px', fontSize: '12px', textAlign: 'center' }}>
                                            เก่งคณิตอย่างเข้าใจ
                                        </Typography.Paragraph>
                                        {/* <div>
                                            <span className='logo-vertical' style={{ color: '#FFB347' }}>
                                                SLC
                                            </span>
                                            <span className='logo-vertical' >
                                                LMS
                                            </span>
                                            <FaGraduationCap style={{ fontSize: '40px', color: '#FFB347' }} />
                                        </div> */}
                                    </div>
                                </Col>
                                <Col xs={6}>
                                    <Typography.Paragraph strong style={{ margin: '0px', fontSize: '10px' }}>
                                        บริษัท เกรท เอ็ดดูเคชั่น เซอร์วิส จำกัด
                                    </Typography.Paragraph>
                                    <Typography.Paragraph style={{ margin: '0px', fontSize: '8px' }}>
                                        8/10 หมู่ 1 แขวง/ตำบล เนินพระ
                                    </Typography.Paragraph>
                                    <Typography.Paragraph style={{ margin: '0px', fontSize: '8px' }}>
                                        เขต/อำเภอ เมืองระยอง จังหวัด ระยอง 21000
                                    </Typography.Paragraph>
                                    <Typography.Paragraph strong style={{ margin: '0px', fontSize: '10px' }}>
                                        {`โทรศัพท์ ${formatPhone('0925386755')}`}
                                    </Typography.Paragraph>
                                    <Typography.Paragraph style={{ margin: '0px', fontSize: '8px' }}>
                                        เลขประจำตัวผู้เสียภาษี 0215562005253
                                    </Typography.Paragraph>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <Row justify="center">
                                <Col >
                                    <Typography.Title level={4} style={{ margin: '0px', fontSize: '16px' }}>
                                        {`ใบเสร็จรับเงิน/RECEIPT (${item})`}
                                    </Typography.Title>
                                </Col>
                            </Row>
                        </div>
                        <div style={{ marginBottom: '24px', padding: '24px' }}>
                            <Row justify="space-between" >
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={4}>
                                            <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                รหัส
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {orderData.student.student_code}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>
                                            <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                ชื่อนักเรียน
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {orderData.student.fname_th} {orderData.student.lname_th ?? ""}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Col xs={4}>
                                            <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                ที่อยู่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {orderData.student?.address ?? "-"}
                                            </Typography.Text>
                                            <br />
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {`แขวง/ตำบล ${orderData.student?.sub_district ?? "-"} เขต/อำเภอ ${orderData.student?.district ?? "-"}`}
                                            </Typography.Text>
                                            <br />
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {`จังหวัด ${orderData.student?.province ?? "-"} รหัสไปรษณีย์ ${orderData.student?.postalcode ?? "-"}`}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={4}>
                                            <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                โทร.
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                {formatPhone(orderData.student?.parent.phone)}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12}>
                                    <Row justify="end">
                                        <Col xs={12}>
                                            <Row justify='space-between'>
                                                <Col >
                                                    <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                        วันที่สั่งซื้อ
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text style={{ margin: '0px', fontSize: '12px' }} >
                                                        {dayjs(orderData.order_date).format('DD-MM-YYYY')}
                                                    </Typography.Text>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row justify="end">
                                        <Col xs={12}>
                                            <Row justify='space-between'>
                                                <Col >
                                                    <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                        เลขที่
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                        {orderData.order_no}
                                                    </Typography.Text>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row justify="end">
                                        <Col xs={12}>
                                            <Row justify='space-between'>
                                                <Col>
                                                    <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                        พนักงานขาย
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                        {orderData.user.fname_th}
                                                    </Typography.Text>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row justify="end">
                                        <Col xs={12}>
                                            <Row justify='space-between'>
                                                <Col>
                                                    <Typography.Text strong style={{ margin: '0px', fontSize: '12px' }}>
                                                        ประเภทการชำระเงิน
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text style={{ margin: '0px', fontSize: '12px' }}>
                                                        {convertPaymentType(orderData.payment_type)}
                                                    </Typography.Text>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className='invoice-table-container'>
                            <Row gutter={[0, 24]}>
                                <Col xs={24}>
                                    <Table
                                        rowKey={(record) => record._id}
                                        columns={[
                                            {
                                                title: 'ลำดับ',
                                                dataIndex: 'no',
                                                key: 'no',
                                                width: '20px',
                                                align: 'right'
                                            },
                                            {
                                                title: 'รายละเอียดสินค้า',
                                                dataIndex: 'product',
                                                key: 'product',
                                                width: '50%',
                                                render: (text, option) => (
                                                    <div>
                                                        <span style={{ display: 'block', fontWeight: 'bold', fontSize: '12px' }}>
                                                            {`${text.name ?? ""}`}
                                                        </span>
                                                        {text.category?.name === 'course' && <span style={{ fontSize: '12px' }}>
                                                            {`เริ่มเรียน ${dayjs(option.start_date).format('DD-MM-YYYY')} ถึง ${dayjs(option.end_date).format('DD-MM-YYYY')}`}
                                                        </span>}
                                                    </div>
                                                )

                                            },
                                            {
                                                title: 'จำนวน',
                                                dataIndex: 'quantity',
                                                key: 'quantity',
                                                // width: '10%',
                                                render: text => <Statistic value={text} valueStyle={{ fontSize: 12, textAlign: 'center' }} />
                                            },
                                            {
                                                title: 'ราคา',
                                                dataIndex: 'price',
                                                key: 'price',
                                                // width: '10%',
                                                render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 12, textAlign: 'right' }} />
                                            },
                                            {
                                                title: 'ราคาสุทธิ',
                                                dataIndex: 'total_price',
                                                key: 'total_price',
                                                // width: '10%',
                                                render: (_, option) => <Statistic value={option.price * option.quantity} precision={2} valueStyle={{ fontSize: 12, textAlign: 'right' }} />
                                            },
                                        ]}
                                        dataSource={orderItems.map((item, idx) => ({ ...item, no: idx + 1 }))}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div style={{ flex: 1 }} />
                        <div style={{ padding: '24px' }}>
                            <Row justify="space-between" >
                                <Col xs={12}>
                                    <Row justify="space-between" gutter={[0, 24]}>
                                        <Col xs={24}>
                                            <Typography.Paragraph
                                                strong
                                                style={{
                                                    margin: '0px',
                                                    fontSize: '12px'
                                                }}
                                            >
                                                เงื่อนไขการขาด-ลา เรียน :
                                            </Typography.Paragraph>
                                            <Typography.Paragraph
                                                // ellipsis={{ rows: 7 }}
                                                style={{
                                                    margin: '0px',
                                                    fontSize: '10px',
                                                    textIndent: '24px'
                                                }}
                                            >
                                                {orderItems.find(f => f.product.category.name === "course")?.product.description ?? "-"}
                                            </Typography.Paragraph>
                                        </Col>
                                        <Col xs={24}>
                                            <img src={qrcode} alt='qrcode' width={80} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={10}>
                                    <Row justify='space-between'>
                                        <Col xs={16}>
                                            <Typography.Paragraph
                                                style={{
                                                    margin: '0px',
                                                    fontSize: '14px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                ราคาสินค้าไม่รวม Vat (บาท) :
                                            </Typography.Paragraph>
                                        </Col>
                                        <Col>
                                            <Statistic
                                                value={orderData.total.toFixed(2)}
                                                precision={2}
                                                valueStyle={{
                                                    fontSize: '14px',
                                                    textAlign: 'right'

                                                }} />
                                        </Col>
                                    </Row>
                                    <Row justify='space-between'>
                                        <Col xs={16}>
                                            <Typography.Paragraph
                                                style={{
                                                    margin: '0px',
                                                    fontSize: '14px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                ภาษีมูลค่าเพิ่ม 7% Vat (บาท) :
                                            </Typography.Paragraph>
                                        </Col>
                                        <Col>
                                            <Statistic
                                                value={orderData.vat.toFixed(2)}
                                                precision={2}
                                                valueStyle={{
                                                    fontSize: '14px',
                                                    textAlign: 'right',

                                                }} />
                                        </Col>
                                    </Row>
                                    <Row justify='space-between'>
                                        <Col xs={16}>
                                            <Typography.Paragraph
                                                strong
                                                style={{
                                                    margin: '0px',
                                                    fontSize: '14px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                ราคารวมสุทธิทั้งหมด (บาท) :
                                            </Typography.Paragraph>
                                        </Col>
                                        <Col>
                                            <Statistic
                                                value={orderData.grand_total}
                                                precision={2}
                                                valueStyle={{
                                                    fontSize: '14px',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold'
                                                }} />
                                        </Col>
                                    </Row>
                                    <div style={{ height: '32px' }} />
                                    <Row justify="end">
                                        <Col style={{ marginLeft: '16px', textAlign: 'center' }}>
                                            <div style={{ width: '100%', height: '32px', borderBottom: '1px solid #f0f0f0' }} />
                                            <Typography.Paragraph style={{ marginTop: '8px' }}>
                                                ผู้รับเงิน (ตัวบรรจง) :
                                            </Typography.Paragraph>
                                            <Typography.Paragraph style={{ marginTop: '32px' }}>
                                                วันที่ -----/-----/-----
                                            </Typography.Paragraph>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                )
            }
        </div >
    )
}

export default Invoice